import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import { Route } from 'vue-router';
import { getFromSessionStorage } from '@/apps/order/helper';

import { useOrdersCreateCustomerStore } from '@/apps/order/stores/ordersCreate';

import CustomerDataInterface from '@/apps/order/interfaces/CustomerDataInterface';

let alreadyFetched = false;

const hasExistingCustomerData = async (to: Route): Promise<void> => new Promise<void>((resolve, reject) => {
  const ctx = to.meta?.ctx;
  nextTick(async () => {
    try {
      const customerStore = useOrdersCreateCustomerStore();
      const { existingCustomerData } = storeToRefs(customerStore);

      let existingCustomer;

      if (!alreadyFetched) {
        existingCustomer = getFromSessionStorage<CustomerDataInterface>(`${ctx}.existingCustomerData`);
        alreadyFetched = true;
      }

      if (existingCustomer !== undefined) {
        existingCustomerData.value = existingCustomer;
      }

      resolve();
    } catch (e) {
      reject(new Error(['fetch existing customer data failed', e].join(' ')));
    }
  });
});

export default hasExistingCustomerData;
